// extracted by mini-css-extract-plugin
module.exports = {"tabela":"TabelaCalendario_tabela__122p4","horas":"TabelaCalendario_horas__17nkB","semana":"TabelaCalendario_semana__CqF72"};